import React from 'react';

import invFooterImg from '../features/InvoiceView/invoice_footer.png';
import invHeaderImg from '../features/InvoiceView/invoice_header2.png';
import cn from './cn';

function InvoiceLayout({ header, children, footer, isHeaderLessPrint = true }) {
    return (
        <>
            <table className="w-full shadow-[0px_0px_60px_0px_rgba(79,98,130,0.10)] print:shadow-none">
                <thead className="print:table-header-group break-inside-avoid">
                    <tr>
                        <th className="text-left print:align-top">
                            <img
                                src={invHeaderImg}
                                alt=""
                                className={cn('w-full hidden print:block', {
                                    'print:invisible': isHeaderLessPrint
                                })}
                            />

                            {header}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td className="print:h-full print:align-top">{children}</td>
                    </tr>
                </tbody>

                <tfoot className=" print:table-footer-group break-inside-avoid">
                    <tr>
                        <td className="print:align-bottom print:h-[130px]">{footer}</td>
                    </tr>
                </tfoot>
            </table>

            <div
                className={cn('fixed bottom-0 left-0 w-full hidden print:block', {
                    'print:invisible': isHeaderLessPrint
                })}
            >
                <img src={invFooterImg} alt="" className="w-full" />
            </div>
        </>
    );
}

export default InvoiceLayout;
